import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/elctdoc/ucr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/ucr-rcpn-mgmt`,
};

export const URLS = {
    ptli0704001q: `${BASE.path}/ptli0704001q`,
    ptli0704002s: `${BASE.path}/ptli0704002s`,
};

export const APIS = {
    // Get the UCR Reception management list. !== UCR 수관 관리 목록을 조회한다.==!
    getUcrRcpnMgmtList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Gets UCR Reception management information. !== UCR 수관 관리 정보를 조회한다.==!
    getUcrRcpnMgmtInfo: (fullUcrNo: any) => {
        return api.get(`${BASE.api}/${fullUcrNo}`);
    },

    // Update UCR Transfer Approval Status !==  UCR 이관 승인 상태 수정 ==!
    updateUcrTrsfAprv: (data: any) => {
        return api.put(`${BASE.api}/${data.ucrNo}-${data.ucrtSrno}/aprv`);
    },
};

const codeYn = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
];

export const SF_UCR_RCPN_MGMT_SRCH: TFormSchema = {
    id: "form_ucrRcpnMgmtSrch",
    schema: {
        ucrNo: {
            type: "text",
            label: "L_UCR_NO",
            letterCase: "upper",
        },
        ucrtAprvDoneYn: {
            type: "select",
            label: "L_UCRT_APRV_DONE_YN",
            options: codeYn,
        },
        ucrtAprvDoneDtm: {
            type: "daterange",
            label: "L_UCRT_APRV_DONE_DTM",
            start: { name: "ucrtAprvDoneDtmStrt" },
            end: { name: "ucrtAprvDoneDtmEnd" },
            rangeButton: 0,
        },
    },
};

export const SG_UCR_RCPN_MGMT_LIST: TGridSchema = {
    id: "grid_ucrRcpnMgmtList",
    options: {
        pagination: "in",
        edit: false,
        index: true,
        height: 500,
    },

    head: [
        { cells: [{ header: "L_UCR_NO", binding: "ucrNo", width: "*" }] },
        { cells: [{ header: "L_UCRT_APLC_TIN", binding: "ucrtAplcTin", width: "12%" }] },
        { cells: [{ header: "L_UCRT_APLC_NM", binding: "ucrtAplcNm", width: "15%" }] },
        { cells: [{ header: "L_UCRT_RECPT_TIN", binding: "ucrtRecptTin", width: "12%" }] },
        { cells: [{ header: "L_UCRT_RECPT_NM", binding: "ucrtRecptNm", width: "15%" }] },
        { cells: [{ header: "L_UCRT_APRV_DONE_YN", binding: "ucrtAprvDoneYn", width: "13%" }] },
        { cells: [{ header: "L_UCRT_APRV_DONE_DTM", binding: "ucrtAprvDoneDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "ucrNo" }] },
        { cells: [{ binding: "ucrtAplcTin" }] },
        { cells: [{ binding: "ucrtAplcNm" }] },
        { cells: [{ binding: "ucrtRecptTin" }] },
        { cells: [{ binding: "ucrtRecptNm", align: "left" }] },
        { cells: [{ binding: "ucrtAprvDoneYn" }] },
        { cells: [{ binding: "ucrtAprvDoneDtm", type: "datetime" }] },
    ],
};

export const SF_UCR_RCPN_MGMT_INFO: TFormSchema = {
    id: "form_ucrRcpnMgmtInfo",
    schema: {
        ucrtSrno: { type: "text" },

        ucrNo: { type: "text", label: "L_UCR_NO", required: true, edit: false },
        ucrRegmCd: {
            type: "text",
            label: "L_UCR_REGM_CD",
            required: true,
            edit: false,
        },

        ucrtAprvDoneYn: { type: "text", label: "L_UCRT_APRV_DONE_YN", edit: false },
        ucrtAprvDoneDtm: { type: "date", label: "L_UCRT_APRV_DONE_DTM", edit: false },
        ucrtApvr: { type: "text", label: "L_UCRT_APVR", edit: false },

        ucrtAplcNm: { type: "text", label: "L_UCRT_APLC_NM", edit: false },
        ucrtAplcCntyCd: { type: "code", label: "L_UCRT_APLC_CNTY_CD", area: "cntyCd", popupSize: "sm", edit: false },
        ucrtAplcTin: { type: "code", label: "L_UCRT_APLC_TIN", area: "tinNo", popupSize: "sm", edit: false },
        ucrtAplcAddr: { type: "text", label: "L_UCRT_APLC_ADDR", edit: false },
        ucrtAplcTelno: { type: "text", label: "L_UCRT_APLC_TELNO", edit: false },
        ucrtAplcFaxNo: { type: "text", label: "L_UCRT_APLC_FAX_NO", edit: false },
        ucrtAplcPostCd: { type: "code", label: "L_UCRT_APLC_POST_CD", area: "postCd", popupSize: "sm", edit: false },
        ucrtAplcPostBaseAddr: { type: "text", label: "L_UCRT_APLC_POST_BASE_ADDR", edit: false },
        ucrtAplcPostDtlAddr: { type: "text", label: "L_UCRT_APLC_POST_DTL_ADDR", edit: false },

        ucrtRecptNm: { type: "text", label: "L_UCRT_RECPT_NM", required: true, edit: false },
        ucrtRecptCntyCd: {
            type: "code",
            label: "L_UCRT_RECPT_CNTY_CD",
            area: "cntyCd",
            popupSize: "sm",
            required: true,
            edit: false,
        },
        ucrtRecptTin: {
            type: "code",
            label: "L_UCRT_RECPT_TIN",
            area: "tinNo",
            popupSize: "sm",
            required: true,
            edit: false,
        },
        ucrtRecptAddr: { type: "text", label: "L_UCRT_RECPT_ADDR", required: true, edit: false },
        ucrtRecptTelno: { type: "text", label: "L_UCRT_RECPT_TELNO", required: true, edit: false },
        ucrtRecptFaxNo: { type: "text", label: "L_UCRT_RECPT_FAX_NO", edit: false },
        ucrtRecptPostCd: { type: "code", label: "L_UCRT_RECPT_POST_CD", area: "postCd", popupSize: "sm", edit: false },
        ucrtRecptPostBaseAddr: { type: "text", label: "L_UCRT_RECPT_POST_BASE_ADDR", edit: false },
        ucrtRecptPostDtlAddr: { type: "text", label: "L_UCRT_RECPT_POST_DTL_ADDR", edit: false },
    },
};

export const SG_TRSF_HIST_LIST: TGridSchema = {
    id: "grid_tsrfHistList",
    options: {
        pagination: "in",
        edit: false,
        index: true,
        checkbox: false,
        height: 150,
    },

    head: [
        { cells: [{ header: "L_UCRT_APLC_NM", binding: "ucrtAplcNm", width: "*" }] },
        { cells: [{ header: "L_UCRT_RECPT_NM", binding: "ucrtRecptNm", width: "*" }] },
        { cells: [{ header: "L_UCRT_APVR", binding: "ucrtApvr", width: "*" }] },
        { cells: [{ header: "L_UCRT_APRV_DONE_DTM", binding: "ucrtAprvDoneDtm", width: "*" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "ucrtAplcNm",
                    type: "text",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "ucrtRecptNm",
                    type: "text",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "ucrtApvr",
                    type: "text",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "ucrtAprvDoneDtm",
                    type: "text",
                },
            ],
        },
    ],
};
